/**
 * @Author: shenyi
 * @Date:   2022-12-14 09:48:42
 * @Last Modified by:   shenyi
 * @Last Modified time: 2022-12-16 14:58:24
 */
import {getAppInfoApi, getLoginUserInfo} from './api'

import {AppModel, MenuItem, Tenant, User} from 'galaxy-framework'

export default class AppService {
    getAppInfo = async (): Promise<AppModel> => {
        let { data: appInfo } = await getAppInfoApi();
        let { data } = await getLoginUserInfo()
        let { menuItems, tenant, hasSearchBar } = appInfo
        let menuItemList = menuItems.map((menuItem: any) => new MenuItem(menuItem))
        tenant = new Tenant(tenant);
        let user = new User(data);
        return new AppModel({ menuItems: menuItemList, tenant, user, hasSearchBar });
    };
}
